import { selectIsColumnsReady } from '../createEagGridStore';
import { useEagGridSelector } from '../useEagGridSelector';
export function useIsColumnsReady() {
  return useEagGridSelector(selectIsColumnsReady);
}